export default __webpack_public_path__ + "static/media/salDeMaras.3a04b19d.jpeg";